export const isNonNegativeNumber = (n: any) => n != null && n >= 0;
export const getDecimalParts = (number: number) => {
  const wholePart = Math.floor(number); // number
  const decimalPart = (number - wholePart).toFixed(2).substring(1);
  return { whole: wholePart, decimal: decimalPart };
};

export const average = (array: number[]) => array.reduce((a, b) => a + b) / array.length;
export const sum = (arr: number[]) => arr.reduce((a, b) => a + b, 0);

export const toNumber = (value?: number | null) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value !== 'number') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  if (Number.isNaN(value)) {
    return null;
  }

  return value;
};

export const toNullableNumber = (value: unknown): number | null => {
  const numeric = typeof value === 'number' ? value : Number.parseFloat(String(value));
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatScore = (value?: number | null) => {
  if (value === undefined || value === null) {
    return '—';
  }
  return Number(value).toFixed(1);
};

export const formatPrice = (
  value = 0,
  symbol: string | null = '$',
  minimumFractionDigits = 0,
  maximumFractionDigits = 2
) => {
  const formatted = (value ?? 0).toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return symbol ? `${symbol}${formatted}` : formatted;
};

export const formatPercent = (value?: string | number | null) => `${value}%`;
